import { render, staticRenderFns } from "./GlobalForm.vue?vue&type=template&id=704ec2b9&scoped=true&"
import script from "./GlobalForm.vue?vue&type=script&lang=js&"
export * from "./GlobalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ec2b9",
  null
  
)

export default component.exports